"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingOptions = exports.marginsOptions = exports.defaultTranslations = exports.defaultSettings = exports.borderYOptions = exports.borderXOptions = exports.borderStyleOptions = exports.borderColorOptions = exports.backgroundSizeOptions = exports.backgroundRepeatOptions = exports.backgroundPositionOptions = exports.backgroundModeOptions = exports.backgroundLoadingMethodOptions = exports.backgroundColorOptions = exports.animationStyleOptions = exports.animationHoverOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _const = require("../const");

var _options;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var values = [];

for (var i = 0; i <= 200; i += 5) {
  values.push({
    label: i,
    value: i
  });
}

var paddingOptions = values; // [
//     {label: 'XL', value: 90},
//     {label: 'L', value: 50},
//     {label: 'M', value: 30},
//     {label: 'S', value: 15},
//     {label: 'XS', value: 5},
// ];

exports.paddingOptions = paddingOptions;
var marginsOptions = values; // [
//     {label: 'XL', value: 90},
//     {label: 'L', value: 50},
//     {label: 'M', value: 30},
//     {label: 'S', value: 15},
//     {label: 'XS', value: 5},
// ];

exports.marginsOptions = marginsOptions;
var backgroundColorOptions = [{
  label: 'None',
  value: 'transparent'
}];
exports.backgroundColorOptions = backgroundColorOptions;
var backgroundPositionOptions = [{
  label: 'Centre',
  value: 'center'
}, {
  label: 'Top',
  value: 'center top'
}, {
  label: 'Bottom',
  value: 'center bottom'
}, {
  label: 'Left',
  value: 'left center'
}, {
  label: 'Right',
  value: 'right center'
}];
exports.backgroundPositionOptions = backgroundPositionOptions;
var backgroundSizeOptions = [{
  label: 'Initial',
  value: 'initial'
}, {
  label: 'Cover',
  value: 'cover'
}, {
  label: 'Contain',
  value: 'contain'
}];
exports.backgroundSizeOptions = backgroundSizeOptions;
var backgroundRepeatOptions = [{
  label: 'None',
  value: 'no-repeat'
}, {
  label: 'Both',
  value: 'both'
}, {
  label: 'Horizontal',
  value: 'repeat-x'
}, {
  label: 'Vertical',
  value: 'repeat-y'
}];
exports.backgroundRepeatOptions = backgroundRepeatOptions;
var backgroundModeOptions = [{
  label: 'Image',
  value: _const.BACKGROUND_MODE_IMAGE_FLAG
}, {
  label: 'Video',
  value: _const.BACKGROUND_MODE_VIDEO_FLAG
}];
exports.backgroundModeOptions = backgroundModeOptions;
var backgroundLoadingMethodOptions = [{
  label: 'Normal',
  value: 'normal'
}, {
  label: 'Preload',
  value: 'preload'
}];
exports.backgroundLoadingMethodOptions = backgroundLoadingMethodOptions;
var borderXOptions = [{
  label: 'None',
  value: 'none'
}, {
  label: 'Both',
  value: 'both'
}, {
  label: 'Left',
  value: 'left'
}, {
  label: 'Right',
  value: 'right'
}];
exports.borderXOptions = borderXOptions;
var borderYOptions = [{
  label: 'None',
  value: 'none'
}, {
  label: 'Both',
  value: 'both'
}, {
  label: 'Top',
  value: 'top'
}, {
  label: 'Bottom',
  value: 'bottom'
}];
exports.borderYOptions = borderYOptions;
var borderColorOptions = [{
  label: 'Default',
  value: 'rgba(0,0,0,0.1)'
}];
exports.borderColorOptions = borderColorOptions;
var borderStyleOptions = [{
  label: 'Solid',
  value: 'solid'
}, {
  label: 'Dashed',
  value: 'dashed'
}, {
  label: 'Dotted',
  value: 'dotted'
}];
exports.borderStyleOptions = borderStyleOptions;
var animationStyleOptions = [{
  label: 'None',
  value: 'none'
}, {
  label: 'Fade In',
  value: 'fade'
}, {
  label: 'Fade Left',
  value: 'fade-left'
}, {
  label: 'Fade Right',
  value: 'fade-right'
}, {
  label: 'Fade Up',
  value: 'fade-top'
}, {
  label: 'Fade Down',
  value: 'fade-bottom'
}, {
  label: 'Slide Left',
  value: 'slide-left'
}, {
  label: 'Slide Right',
  value: 'slide-right'
}, {
  label: 'Slide Up',
  value: 'slide-top'
}, {
  label: 'Slide Down',
  value: 'slide-bottom'
}, {
  label: 'Zoom In',
  value: 'zoom'
}, {
  label: 'Zoom Left',
  value: 'zoom-left'
}, {
  label: 'Zoom Right',
  value: 'zoom-right'
}, {
  label: 'Zoom Up',
  value: 'zoom-top'
}, {
  label: 'Zoom Down',
  value: 'zoom-bottom'
}, {
  label: 'Bounce In',
  value: 'bounce'
}, {
  label: 'Bounce Left',
  value: 'bounce-left'
}, {
  label: 'Bounce Right',
  value: 'bounce-right'
}, {
  label: 'Bounce Up',
  value: 'bounce-top'
}, {
  label: 'Bounce Down',
  value: 'bounce-bottom'
}];
exports.animationStyleOptions = animationStyleOptions;
var animationHoverOptions = [{
  label: 'None',
  value: 'none'
}, {
  label: 'Zoom',
  value: 'zoom'
}];
exports.animationHoverOptions = animationHoverOptions;
var defaultTranslations = {
  backgroundColorInput: 'Background colour',
  backgroundColorOpacityInput: 'Background colour opacity',
  backgroundImageInput: 'Background image',
  backgroundPositionInput: 'Background position',
  backgroundSizeInput: 'Background size',
  backgroundRepeatInput: 'Background repeat',
  backgroundModeInput: 'Background mode',
  backgroundVideoInput: 'Background video',
  backgroundPosterframeInput: 'Background video posterframe',
  borderXInput: 'X-axis Display',
  borderYInput: 'Y-axis Display',
  borderColorInput: 'Border colour',
  borderWidthInput: 'Border width',
  borderStyleInput: 'Border style',
  animationStyleInput: 'Animation style',
  animationDurationInput: 'Animation duration',
  animationDelayInput: 'Animation delay'
};
exports.defaultTranslations = defaultTranslations;
var defaultSettings = {
  DecoratorComponent: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "There is no decorator component"),
  DecoratorFormComponent: null,
  options: (_options = {}, _defineProperty(_options, _const.TYPE_PADDING, paddingOptions), _defineProperty(_options, _const.TYPE_MARGIN, marginsOptions), _defineProperty(_options, _const.TYPE_BACKGROUND_COLOR, backgroundColorOptions), _defineProperty(_options, _const.TYPE_BACKGROUND_POSITION, backgroundPositionOptions), _defineProperty(_options, _const.TYPE_BACKGROUND_SIZE, backgroundSizeOptions), _defineProperty(_options, _const.TYPE_BACKGROUND_REPEAT, backgroundRepeatOptions), _defineProperty(_options, _const.TYPE_BACKGROUND_MODE, backgroundModeOptions), _defineProperty(_options, _const.TYPE_BACKGROUND_LOADING_METHOD, backgroundLoadingMethodOptions), _defineProperty(_options, _const.TYPE_BORDER_X, borderXOptions), _defineProperty(_options, _const.TYPE_BORDER_Y, borderYOptions), _defineProperty(_options, _const.TYPE_BORDER_COLOR, borderColorOptions), _defineProperty(_options, _const.TYPE_BORDER_STYLE, borderStyleOptions), _defineProperty(_options, _const.TYPE_ANIMATION_STYLE, animationStyleOptions), _defineProperty(_options, _const.TYPE_ANIMATION_HOVER, animationHoverOptions), _options),
  translations: defaultTranslations,
  decoratePlugins: function decoratePlugins(plugins) {
    return plugins;
  }
};
exports.defaultSettings = defaultSettings;